import highchartsMore from 'highcharts/highcharts-more';
import Highcharts from 'highcharts/highstock';
import HC_boost from 'highcharts/modules/boost';
import HC_boost_canvas from 'highcharts/modules/boost-canvas';
import HC_exporting from 'highcharts/modules/exporting';
import React from 'react';

import { getColomChart, getVehicleColomChart } from './function';
import './styles.scss';

highchartsMore(Highcharts);
HC_exporting(Highcharts);
HC_boost_canvas(Highcharts);
HC_boost(Highcharts);

export default class StockGraph extends React.Component {
  constructor(props, context) {
    super(props, context);
    const options = this.initGraph(props);
    this.state = { options };
  }

  componentDidMount() {
    this.draw(this.props);
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.data !== nextProps.data) {
      return true;
    } else {
      return false;
    }
  }

  componentDidUpdate() {
    const options = this.initGraph();
    this.setState({
      options,
    });
    this.draw(this.props);
  }

  componentWillUnmount() {
    setTimeout(() => {
      this.chart.destroy();
    }, 0);
  }

  draw(props) {
    this.chart = Highcharts.chart(this.container, { ...this.state.options });
    this.chart.reflow();
  }

  initGraph = props => {
    let options;
    if (this.props.chartType === 'BATT_REL_COL_TYPE') {
      options = getColomChart(
        this.props.data,
        'BATT_REL_COL_TYPE',
        this.props.redirectToTimetrend,
        this.props.report
      );
    } else if (this.props.chartType === 'BATT_STR_COL_TYPE') {
      options = getColomChart(
        this.props.data,
        'BATT_STR_COL_TYPE',
        this.props.redirectToTimetrend,
        this.props.report
      );
    } else if (this.props.chartType === 'VEH_REL_COL_TYPE') {
      options = getVehicleColomChart(
        this.props.data,
        'VEH_REL_COL_TYPE',
        this.props.redirectToTimetrend
      );
    } else if (this.props.chartType === 'VEH_STR_COL_TYPE') {
      options = getVehicleColomChart(
        this.props.data,
        'VEH_STR_COL_TYPE',
        this.props.redirectToTimetrend
      );
    }

    if (Highcharts.getOptions().exporting) {
      const contextButton =
        Highcharts.getOptions().exporting.buttons.contextButton; // eslint-disable-line
      contextButton.menuItems = contextButton.menuItems.filter(item => {
        return item !== 'downloadPDF';
      });
    }

    return options;
  };

  mouselog = () => {
    this.chart.tooltip.hide(true);
  };

  render() {
    return (
      <div
        id="stock_graph"
        className="chart"
        ref={ref => (this.container = ref)}
        onMouseLeave={this.mouselog}
      />
    );
  }
}
